var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom_upload"},[_c('div',{staticClass:"custom_content",style:({ backgroundImage: `url(${_vm.border})` })},[_c('UploadFile',{staticClass:"upload",attrs:{"type":"","view":false,"size":_vm.size},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }